import { Link, Outlet, useLocation } from "react-router-dom";
import { useSession } from "../lib/session";

export default function Layout() {
  const { pathname } = useLocation();
  const { state, signOut } = useSession();
  const onPortal = pathname === "/";

  return (
    <div className="min-h-screen bg-canvas">
      <header className="sticky top-0 z-10 border-b border-line bg-canvas/90 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center gap-2 px-4 py-3">
          <Link to="/" className="text-[15px] font-bold tracking-tight">
            경매 작업대
          </Link>

          <nav className="ml-auto flex items-center gap-1 text-[13px]">
            {!onPortal && (
              <>
                <Link
                  to="/properties"
                  className="rounded-full px-3 py-1.5 text-ink-soft hover:bg-surface"
                >
                  물건 목록
                </Link>
                <a
                  href="/study"
                  className="rounded-full px-3 py-1.5 text-ink-soft hover:bg-surface"
                >
                  학습
                </a>
              </>
            )}

            {state.kind === "member" && (
              <button
                type="button"
                onClick={() => void signOut()}
                className="rounded-full px-3 py-1.5 text-ink-soft hover:bg-surface"
              >
                로그아웃
              </button>
            )}
            {(state.kind === "anonymous" || state.kind === "unapproved") && (
              <Link
                to="/login"
                className="rounded-full bg-ink px-3.5 py-1.5 font-semibold text-white"
              >
                로그인
              </Link>
            )}
          </nav>
        </div>

        {state.kind === "skeleton" && (
          <div className="border-t border-line bg-surface px-4 py-2 text-center text-[12px] text-ink-soft">
            인증이 구성되지 않은 골격 모드입니다. 보이는 물건은 전부 가상 샘플입니다.
          </div>
        )}
      </header>

      <main className="mx-auto max-w-5xl px-4 pb-24 pt-6">
        <Outlet />
      </main>
    </div>
  );
}
